import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Badge } from './ui/badge';
import { useLanguage } from '../contexts/LanguageContext';

export const FAQ = () => {
  const { t } = useLanguage();
  
  const faqs = [
    {
      question: t('faq.questions.whatIsShenbury.question'),
      answer: t('faq.questions.whatIsShenbury.answer')
    },
    {
      question: t('faq.questions.howDoesItWork.question'),
      answer: t('faq.questions.howDoesItWork.answer')
    },
    {
      question: t('faq.questions.whatMakesDifferent.question'),
      answer: t('faq.questions.whatMakesDifferent.answer')
    },
    {
      question: t('faq.questions.revenueModel.question'),
      answer: t('faq.questions.revenueModel.answer')
    },
    {
      question: t('faq.questions.dataPrivacy.question'),
      answer: t('faq.questions.dataPrivacy.answer')
    },
    {
      question: t('faq.questions.verificationServices.question'),
      answer: t('faq.questions.verificationServices.answer')
    },
  ];

  return (
    <section className="py-20 sm:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-subtle" />
      <div className="absolute top-0 left-1/3 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge variant="outline" className="glass border-primary/30 mb-4">
            <HelpCircle className="w-4 h-4 mr-2 inline" />
            {t('faq.badge')}
          </Badge>
          <h2 className="font-serif font-bold mb-6 text-gradient-primary">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="glass border-card-border rounded-xl px-6 hover-lift"
              >
                <AccordionTrigger className="text-left font-serif text-lg text-foreground hover:text-primary-glow">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-4">
            {t('faq.ctaQuestion')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/whitepaper"
              className="inline-flex items-center justify-center px-8 py-3 rounded-lg bg-gradient-primary text-foreground font-semibold shadow-elegant hover:shadow-gold hover:scale-105 transition-all duration-300"
            >
              {t('faq.ctaWhitepaper')}
            </Link>
            <Link
              to="/technical-paper"
              className="inline-flex items-center justify-center px-8 py-3 rounded-lg border border-border bg-transparent hover:bg-muted text-foreground transition-all duration-300"
            >
              {t('faq.ctaTechnical')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};